/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-form-auto.vue?vue&type=template&id=fb9eb0d4&scoped=true"
import script from "./j-form-auto.vue?vue&type=script&lang=js"
export * from "./j-form-auto.vue?vue&type=script&lang=js"
import style0 from "./j-form-auto.vue?vue&type=style&index=0&id=fb9eb0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9eb0d4",
  null
  
)

export default component.exports